import React, { useEffect, useState } from 'react';
import { Space, Form, Input, Upload, message, Modal, Row, Col, Select } from '@drip/drip-design';
import { LoadingOutlined, PlusOutlined } from '@drip/drip-design-icons';
import { customRequest } from '@/common/utils/image-utils/custom-request';
import { connect } from 'react-redux';
import { validErp } from '../apis.js';
import './index.less';

function ApplyBaseFrom(props: any) {
  const { fromData, onFormSubmit, form, erp, realName, organizationName, visible, delFileList } = props;
  const [uploadLoading, setUploadLoading] = useState(false);
  const [fileList, setfileList] = useState([]);
  const [previewImage, setPreviewImage] = useState('');
  const [previewVisible, setPreviewVisible] = useState(false);

  useEffect(() => {
    if (visible) {
      form.setFieldsValue({ applicantName: realName, applicantErp: erp, applicantDept: organizationName });
    } else {
      setfileList([]);
    }
  }, [visible]);

  useEffect(() => {
    if (visible) {
      setfileList(delFileList);
    }
  }, [visible, delFileList]);

  const beforeUpload = (file: any) => {
    const isJpgOrPng = file.type === 'image/jpg' || file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
      message.error('图片格式必须是jpg、jpeg、png!');
    }
    const isLtMax = file.size / 1024 / 1024 <= 50;
    if (!isLtMax) {
      message.error('图片大小不超过50M!');
    }
    return isJpgOrPng && isLtMax;
  };

  function handlePicUploadChange(e: any) {
    const { fileList } = e;
    setfileList(fileList);
  }

  const uploadButton = (
    <div>
      {uploadLoading ? <LoadingOutlined /> : <PlusOutlined />}
      <div style={{ marginTop: 8 }}>上传图片</div>
    </div>
  );

  async function handlePreview(file: any) {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewVisible(true);
  }

  function getBase64(file: any) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  }

  const checkErp = (code: any, value: any) => {
    return new Promise((resolve, reject) => {
      if (code !== 'goodsCategoryApprover') {
        return resolve('');
      }
      if (!value) {
        return reject();
      }
      validErp({ erps: value }).then(({ ret, msg, data }) => {
        if (ret === '0') {
          return resolve('');
        } else {
          return reject(new Error(msg));
        }
      });
    });
  };

  return (
    <div>
      {fromData.length > 0 && (
        <Row gutter={[16, 16]}>
          {' '}
          {fromData.map((item: any) => (
            <Col span={8} key={item.code}>
              {' '}
              {item.dataType === 1 ? (
                item.code === 'applicantWhiteCause' ? (
                  <Form.Item
                    name={item.code}
                    label={item.name}
                    rules={[{ required: item.required, message: `请输入${item.name}` }]}
                    labelAlign="left"
                    style={{ display: 'flex', flexDirection: 'column', width: 367 }}
                  >
                    <Input.TextArea />
                  </Form.Item>
                ) : (
                  <Form.Item
                    name={item.code}
                    label={item.name}
                    labelAlign="left"
                    style={{ display: 'flex', flexDirection: 'column', width: 367 }}
                    rules={[
                      {
                        validator: (_: any, value: any) => checkErp(item.code, value),
                      },
                      { required: item.required, message: `请输入${item.name}` },
                    ]}
                    validateTrigger="onBlur"
                  >
                    <Input disabled={item.readOnly} />
                  </Form.Item>
                )
              ) : item.dataType === 2 ? (
                <Space>
                  <Form.Item
                    name={item.code}
                    label={item.name}
                    rules={[{ required: item.required, message: `请上传${item.name}` }]}
                    labelAlign="left"
                    style={{ display: 'flex', flexDirection: 'column', width: 367 }}
                    extra={
                      <span style={{ display: 'block', marginTop: '10px' }}>
                        大小50MB以内；支持扩展名png、jpg、jpeg；最多上传10张
                      </span>
                    }
                  >
                    <Upload
                      accept="image/*"
                      listType="picture-card"
                      onChange={handlePicUploadChange}
                      customRequest={(e: any) => {
                        customRequest(e);
                      }}
                      beforeUpload={beforeUpload}
                      fileList={fileList}
                      onPreview={handlePreview}
                    >
                      {fileList.length >= 10 ? null : uploadButton}
                    </Upload>
                  </Form.Item>
                </Space>
              ) : item.dataType === 18 ? (
                <Form.Item
                  name={item.code}
                  label={item.name}
                  rules={[{ required: item.required, message: `请选择${item.name}` }]}
                  labelAlign="left"
                  style={{ display: 'flex', flexDirection: 'column', width: 400 }}
                >
                  <Select placeholder="请选择">
                    {item?.optionValues?.map((optionValues: any) => {
                      return (
                        <Select.Option key={optionValues.value} value={optionValues.value}>
                          {optionValues.text}
                        </Select.Option>
                      );
                    })}
                  </Select>
                </Form.Item>
              ) : null}
            </Col>
          ))}
        </Row>
      )}
      <Modal visible={previewVisible} footer={null} onCancel={() => setPreviewVisible(false)}>
        <img alt="example" style={{ width: '100%' }} src={previewImage} />
      </Modal>
    </div>
  );
}

export default connect((state: any) => {
  if (!state.userInfo.userMap || !state.userInfo.userMap.erp) return {};
  return {
    erp: state.userInfo.userMap.erp,
    realName: state.userInfo.userMap.realName,
    organizationName: state.userInfo.userMap.organizationName,
  };
})(ApplyBaseFrom);
